import type { BrandSpecial } from '@iheartjane/data-access';
import { brandSpecialHasSegments } from '@iheartjane/menu';

/* eslint-disable-next-line no-restricted-imports */
import type { PendingCartProduct } from '@jane/shared/models';

export const brandSpecialOrProductHasSegments = ({
  brandSpecial,
  cartProduct,
}: {
  brandSpecial?: Pick<
    BrandSpecial,
    'exclude_user_segments' | 'include_user_segments'
  >;
  cartProduct?: Pick<PendingCartProduct, 'brand_special_has_segment_rules'>;
}) => {
  if (brandSpecial) {
    return brandSpecialHasSegments(brandSpecial);
  }

  if (cartProduct) {
    return Boolean(cartProduct.brand_special_has_segment_rules);
  }

  return false;
};
